import { useParams } from 'react-router-dom';
import { SamplePageNameEn } from '../lib/FL';

const useBusinessParam = (): SamplePageNameEn => {
  const { business } = useParams<{ business: string }>();
  switch (business) {
    case 'index':
    case 'construction':
    case 'reform':
      return business;
    default:
      return 'index';
  }
};

export default useBusinessParam;
